package net.zagart.ai.core.client.deepseek

import io.ktor.client.HttpClient
import io.ktor.client.request.get
import io.ktor.client.statement.bodyAsText
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json

@Serializable
data class WorkerConfig(val apiKey: String)

suspend fun getDeepseekApiKey(workerApiBaseUrl: String): String {
    val client = HttpClient()
    try {
        val url = "${workerApiBaseUrl.trimEnd('/')}/config"
        val response = client.get(url)
        return Json.decodeFromString<WorkerConfig>(response.bodyAsText()).apiKey
    } finally {
        client.close()
    }
}
